export const II_UPDATE_LIBRARY = 'II_UPDATE_LIBRARY';
export const II_UPDATE_IMAGE_LIKE_STATUS = 'II_UPDATE_IMAGE_LIKE_STATUS';
export const II_UPDATE_CREATION_IMAGE_STATUS =
  'II_UPDATE_CREATION_IMAGE_STATUS';
export const II_SELECT_OWN_IMAGE = 'II_SELECT_OWN_IMAGE';
export const II_LIKE_LOOKBOARD_GTL = 'II_LIKE_LOOKBOARD_GTL';
export const II_VOTE_LOOKBOARD_GTL = 'II_VOTE_LOOKBOARD_GTL';
